import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-507b5791")

_pushScopeId("data-v-507b5791")
const _hoisted_1 = { class: "flex flex-col p-4 rounded bg-primary-dark" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "p-4 pt-0 text-2xl" }, "Metrics", -1)
const _hoisted_3 = { class: "overflow-y-auto" }
const _hoisted_4 = { class: "w-full table-auto" }
const _hoisted_5 = { class: "sticky top-0 border-b shadow-lg bg-primary-dark" }
const _hoisted_6 = { class: "border-t" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("table", _hoisted_4, [
        _createVNode("thead", _hoisted_5, [
          _createVNode("tr", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnHeaders, (header, index) => {
              return (_openBlock(), _createBlock("th", {
                class: "p-4 text-xs text-left uppercase",
                key: index
              }, _toDisplayString(_ctx.formatColumnTitle(header)), 1))
            }), 128))
          ])
        ]),
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (tableViewModel, index) => {
            return (_openBlock(), _createBlock("tr", {
              key: index,
              class: [{ highlight: tableViewModel.highlight }, "border-t"]
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnHeaders, (header, index) => {
                return (_openBlock(), _createBlock("td", {
                  class: "p-4 text-xs",
                  key: index
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(tableViewModel.getCellComponent(header)), {
                    data: tableViewModel.classMetric[header]
                  }, null, 8, ["data"]))
                ]))
              }), 128))
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
})